import { Accounts, LocalisedCustomNames } from '../../shared-types'
import {
  FormatRequestDataOptions,
  buildRequestItem,
} from './formatRequestDataUtils'

const formatJsonRequestData = ({
  accounts,
  groups,
  groupMappedAccounts,
  mappedAccountIds,
  shouldUseOriginalNames,
  supportedLocales,
}: FormatRequestDataOptions): Accounts =>
  Object.keys(mappedAccountIds).reduce((acc, x) => {
    const key = parseInt(x, 10)
    const groupId = mappedAccountIds[key]
    const mappedNumber = groupMappedAccounts[groupId][key].mappedNumber

    const account = buildRequestItem({
      id: key,
      mappedNumber,
      account: accounts[key],
      group: groups[groupId],
      shouldUseOriginalNames,
      supportedLocales,
    })

    return {
      ...acc,
      [key]: {
        ...account,
        ...supportedLocales.reduce(
          (acc, locale) => ({
            ...acc,
            [`customName${locale}`]: account[`name${locale}`],
          }),
          {} as Record<keyof LocalisedCustomNames, string>
        ),
      },
    }
  }, {} as Accounts)

export default formatJsonRequestData
